import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FavIcon from '../../../assets/images/favicon.png';
import { LocalStorageKey } from "../../../constants/localStorageKeys";
import { LanguageService } from "../../../services/languageService";
import { ButtonWrapper } from "../formUtilities/useButton";
import { TextWrapper } from "../formUtilities/useTextWrapper";
import { HowItWorksDialog } from "../howItWorkDialog";
import { UserService } from "../../../services/userService";
// HowItWorksDialog

export const NewInvestorHIWDialog = () => {
  const languageService = new LanguageService();
  const userService = new UserService();
  const [show, setShow] = useState(false);
  const [showHowWorks, setShowHowWorks] = useState(false);
  const { t } = useTranslation();

  const isAr = () => languageService.isArabic();

  useEffect(() => {
    checkIfUserLoggedInFirst();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkIfUserLoggedInFirst = async () => {
    let alreadyShowed = localStorage.getItem(LocalStorageKey.userLoggedInFirstTime) ?
      localStorage.getItem(LocalStorageKey.userLoggedInFirstTime) === "1" : false;
    if (!alreadyShowed) {
      let checkPointData = localStorage.getItem(LocalStorageKey.checkPointServey) ? JSON.parse(localStorage.getItem(LocalStorageKey.checkPointServey)) : null;
      if (!checkPointData) {
        let resp = await userService.getCheckPoint();
        checkPointData = resp.data;
        localStorage.setItem(LocalStorageKey.checkPointServey, JSON.stringify(checkPointData));
      }
      if (checkPointData?.isFirstLogin) {
        setShow(true);
      }
    }
  };

  const onSubmit = (resp) => {
    localStorage.setItem(LocalStorageKey.userLoggedInFirstTime, "1");
    setShow(false);
    if (resp) {
      setShowHowWorks(true);
    }
  };

  return <Box>
    <Box className={`${show ? 'fixed fade-in how-it-work-info-popup' : 'hidden'}  bottom-[20px] w-[350px] z-[99999] rounded-lg bg-white ${isAr() ? 'md:left-[20px] right-auto' : 'right-[20px] left-auto'} p-6`}>
      <Box className='flex items-center'>
        <img src={FavIcon} alt="fav-icon" className="w-[38px] h-[38px]"></img>
        <Box className='w-8'></Box>
        <Box className='flex flex-col'>
          <TextWrapper classList="!text-[16px] !font-[500]" text={t('welcomeToFundingSouq')} />
          <TextWrapper classList="!text-[13px]" text={t('takeAQuick3Minute')} />
          <Box className='flex flex-row items-center mt-2'>
            <ButtonWrapper classList="secondary" label={t('letStart')} onClick={() => {
              onSubmit(true);
            }} />
            <Box className='w-2'></Box>
            <ButtonWrapper onClick={() => {
              onSubmit(false);
            }} variant={'outlined'} label={t('iAmOk')} />
          </Box>
        </Box>
      </Box>
    </Box>
    {showHowWorks ? <HowItWorksDialog onClose={() => {
      setShowHowWorks(false);
    }} showHowWorks={showHowWorks} /> : null}
  </Box>;
};